import store from "@/store";

export default [
    {
        path: '/',
        name: 'homepage',
        // redirect: {name: 'checkins-list'}
        component: () => import(/* webpackChunkName: "homepage" */ '../views/HomePage.vue'),
        beforeEnter: (to, from, next) => {
            if (to.query.hasOwnProperty('voucher')) {
                store.commit('SET_VOUCHER_TO_REEDEM', to.query.voucher)
            }
            if (store.getters['auth/isAuthenticated']) {
                next('/checkins')
                return
            }
            next()
        },
    },
]

